module.exports = __webpack_public_path__ + "src/images/products/allAmerican/83_Nash Cotton T-Shirt.png";